@if (loading) {
<bracelit-preloader [absoluteCentered]="true"
  style="height: 100%; display: flex; justify-content: center; align-items: center;"></bracelit-preloader>
} @else {
<div style="display: flex; flex-direction: column; flex-wrap: wrap; align-items: start; justify-content: start;">
  <div
    style="flex: 1 1 100%; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center; padding: 0px 5px 0px 10px; width: 100%;">
    <div style="display: flex !important; align-items:center !important; justify-content:right !important;
    height:fit-content !important; width:100% !important;" (click)="onGoBack()">
      <img [src]="'assets/icons/crossClose.svg'" style="cursor: pointer; margin-right: 10px;">
    </div>
    <div style="display: flex !important; align-items:center !important; justify-content:center !important;
    height:fit-content !important; width:100% !important; flex-direction: column;">
      <mat-icon svgIcon="transactions-large" class="primary-color" style="width: 49px; height: 49px;"></mat-icon>
      <div class="voucher-title bold-20px-center-marine primary-border-100"
        style="margin-bottom: 20px !important; margin-top: 10px !important;">
        {{headerText}}
      </div>
    </div>
    <div class="bracelit-card-content"
      style="display: flex !important; flex-direction:column !important; max-height: calc(60vh - 134px) !important; width: 95% !important; overflow-y:scroll !important;">

      @if (reservedTickets.length === 0) {
      <div class="transaction-row" style="display: flex; flex-direction: row; flex-wrap: wrap; flex: 1 1 100%;">
        <div
          style="flex: 1 1 100%; display: flex; flex-direction: row; justify-content: center; align-items: center; color: #0F223E; padding: 5em 25px; font-size: 18px; text-align: center;">
          <span>{{noTicketsText}}</span>
        </div>
      </div>
      }

      @for (purchase of reservedTickets; track purchase.id) {
      <div class="transaction-row" style="flex: 1 1 100%; flex-direction: column !important;">
        @for (ticket of purchase.tickets; track ticket.id) {
        <div class="transaction-container grey-border-100"
          style="flex: 1 1 calc(100% - 36px); display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center; margin: 10px 0px 0px 0px; width: 95% !important;">
          <details style="width: 100%;">
            <summary class="transaction-container transparent-border-100"
              style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: start; margin: 10px 0px 0px 0px; width: 100%;">
              <div
                style="display: flex; align-items: center; justify-content: center; margin-right: 10px; min-width: 16px; height: 16px; flex-shrink: 0;">
                <mat-icon svgIcon="qrcode" class="qrcode-icon primary-color"
                  style="width: 16px; height: 16px; font-size: 16px; line-height: 16px;"></mat-icon>
              </div>
              <div class="sub-row"
                style="display:flex; align-items:center; justify-content:space-between; flex: 1; min-width: 0;">
                <div class="transaction-title bold-14px-left-marine" style="flex: 1 1 60%;">
                  {{ticket.ticketName || 'Entrada'}}
                </div>
                <div class="transaction-amount bold-16px-right-marine" style="display:flex; align-items:center">
                  @if (ticket.ticketPrice) {
                  <span>{{ticket.ticketPrice | currency:'EUR'}}</span>
                  }
                </div>
              </div>
              <div class="sub-row" style="flex: 1 1 100%; width: 100%;margin: 0px 0px 10px 0px; padding-left: 26px;">
                <div class="light-12px-left-grey" style="flex: 1 1 50%;">
                  @if (ticket.createdAt) {
                  <span>{{ticket.createdAt | date : 'dd-MM-yyyy'}} | {{ticket.createdAt |
                    date
                    : 'HH:mm'}}h</span>
                  }
                </div>
              </div>
            </summary>
            @if (ticket.data) {
            @for (data of getValues(ticket.data); track data) {
            <div class="payment-details-date light-14px-center-primary"
              style="display: flex; justify-content: space-between; width: 100% !important;">
              {{data}}
            </div>
            }
            }
            @if (ticket.qrCode) {
            <div class="payment-details-date light-14px-center-primary"
              style="display: flex; justify-content: center; width: 100% !important; margin-bottom: 10px;">
              <div>
                <bee-qr-generator [qrData]="ticket.qrCode" [qrSize]="150"></bee-qr-generator>
                <p class="light-14px-center-primary" style="margin: 0 !important; padding: 0 !important;">{{
                  maxLength(ticket.qrCode, 8) }}</p>
                <button class="white-background bold-14px-center-marine" mat-raised-button type="button"
                  style="box-shadow: none !important; border: 1px solid #0F223E; margin-top: 15px; margin-bottom: 10px;"
                  (click)="downloadQrCode(ticket.id)">
                  {{ 'qrDialog.download' | translate }}
                </button>
              </div>
            </div>
            }
          </details>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
}